export const APP_NAME = 'Rayo Push Notification';
